import { render, staticRenderFns } from "./PerfilAbonosView.vue?vue&type=template&id=3ff32a26"
import script from "./PerfilAbonosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilAbonosView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports